import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Static_modal from "../user/etc/Static_modal";
//import AuthService from "../../services/auth.service";
import "./Regulator.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import RegulatorService from "../../services/regulator.service";
import RegulatorDroneModal from "./RegulatorDroneModal";
//Steps
import Regulator_Status from "../../Style_Component/Steps/Regulator_Drone_Status";
import Tooltip from "@mui/material/Tooltip";
import PaidIcon from "@mui/icons-material/Paid";
//// prime react
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import "./prime_edit.css";

//icon
import { AiFillDollarCircle } from "react-icons/ai";
import { GiDeliveryDrone } from "react-icons/gi";
import { FaUserAstronaut } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { FaRegFileLines } from "react-icons/fa6";
import fileicon from "../../picture/file-icon.png";
// import docgif from "../../picture/document-office.gif";
import docgif from "../../picture/search.gif";
import payment from "../../picture/payment.gif";

export default function Regulator_Drone() {
  const [selectedInformation, setSelectedInformation] = useState([]);
  const [datadrone, setDatadrone] = useState([]);
  const [datauserdrone, setDatauserdrone] = useState([]);
  const [data, setData] = useState([]);
  const [drone_ID, setDrone_ID] = useState("");
  const [updatedArray, setUpdatedArray] = useState([]);
  const [showInformation, setShowInformation] = useState(false);
  const [showcomment, setShowcomment] = useState(false);
  const [showpayment, setShowpayment] = useState(false);
  const [showsearch, setShowSearch] = useState(false);
  const [checkreply, setCheckreply] = useState(false);
  const [confirmdrone, setConfirmdrone] = useState(undefined);
  const [comment, setComment] = useState("-");
  const [isNBTC, setIsNBTC] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const handleClose = () => {
    setShowInformation(false);
    setShowcomment(false);
    setShowpayment(false);
    setShowSearch(false);
  };
  const createPost = (req_num) => {
    const queryString = `number=${encodeURIComponent(drone_ID)}`;
    const url = `/user/drone/statusDroneSec?${queryString}`;

    window.open(url, "_blank");
    // Navigate("/user/drone/statusDroneSec", {
    //   state: {
    //     drone_id: req_num,
    //   },
    // });
  };
  const handleShowComment = () => {
    setShowcomment(!showcomment);
  };

  const handleclick = () => {
    const check = RegulatorService.UpdateDroneRegisStatus(
      drone_ID,
      4,
      "โปรดชำระค่าบริการ"
    );
    if (check != null)
      check.then((res) => {
        console.log(res);
        setShowInformation(false);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
  };
  const handleconfirm = (type) => {
    const check = RegulatorService.UpdateDroneRegisStatus(drone_ID, type, "");
    if (check != null)
      check.then((res) => {
        console.log(res);
        setShowInformation(false);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
  };
  const handlePaymentconfirm = () => {
    const check = RegulatorService.UpdateDroneRegisStatus(drone_ID, 2, "");
    if (check != null)
      check.then((res) => {
        console.log(res);
        setShowpayment(false);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
  };
  const handlesentcomment = () => {
    const check = RegulatorService.UpdateDroneRegisStatus(drone_ID, 9, comment);
    if (check != null)
      check.then((res) => {
        console.log(res);
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
  };
  const handlegetdatadrone = (droneid) => {
    const check = RegulatorService.GetOneDataDrone(droneid);
    if (check != null)
      check.then((res) => {
        console.log(res);
        setDatadrone(res.data.drone_data);
        setDatauserdrone(res.data.drone_data.userdata);
        setShowInformation(true);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
  };
  async function checkrole() {
    if (sessionStorage.getItem("type_user") === "nbtc") {
      setIsNBTC(true);
    }
  }
  const GetDroneList = () => {
    const CheckUndefine = RegulatorService.dronelist();
    if (CheckUndefine != null) {
      CheckUndefine.then((res) => {
        console.log(res);
        setData(res.data.drone_data);
        setTimeout(() => {
          setLoading(true);
        }, 1000);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
    }
  };
  // const { state } = useLocation();
  useEffect(() => {
    //droneuser();
    GetDroneList();
    updateArrayWithNewKey();
    checkrole();
  }, []);

  useEffect(() => {
    updateArrayWithNewKey();
  }, [data]);
  const pageStyle = {
    position: "absolute",
    width: "90%",
    height: "86px",
    left: "5%",
    top: "220px",
    background: "linear-gradient(90deg, #023E8A 0%, #0096C7 100%)",
    color: "#FFFFFF",
    textAlign: "center",
    paddingTop: "25px",
    boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    fontSize: "32px",
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div className="btn-group" role="group">
      {options.map((option) => {
        const isSelect = currSizePerPage === `${option.page}`;
        return (
          <button
            key={option.text}
            type="button"
            onClick={() => onSizePerPageChange(option.page)}
            className={`btn ${isSelect ? "btn-secondary" : "btn-warning"}`}
          >
            {option.text}
          </button>
        );
      })}
    </div>
  );
  const updateArrayWithNewKey = () => {
    const newArray = data.map((obj, index) => {
      //console.log(data.length);
      const newObj = { ...obj };
      newObj.payment = (
        <>
          {newObj.regis_status_text === "ตรวจสอบการชำระเงิน" ? (
            <div
              onClick={() => {
                setShowpayment(true);
                setDrone_ID(newObj.drone_id);
              }}
              style={{ cursor: "pointer" }}
            >
              <AiFillDollarCircle style={{ color: "green" }} />
            </div>
          ) : (
            ""
          )}
        </>
      );
      newObj.detail = (
        <div>
          {newObj.regis_status_text === "อยู่ระหว่างการพิจารณา" ||
          newObj.regis_status_text === "อยู่ระหว่างพิจารณา" ? (
            <p
              onClick={() => {
                setSelectedInformation([
                  newObj.drone_req_num,
                  newObj.brand_model,
                  newObj.registration_date,
                  newObj.caat,
                  newObj.nbtc,
                  newObj.regis_status_text,
                ]);

                //setO_id(newObj.operation_id);
                setDrone_ID(newObj.drone_id);
                handlegetdatadrone(newObj.drone_id);
                setConfirmdrone(true);
                //handleclick()
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                alt="Agreement"
                src={docgif}
                style={{ width: "37px", height: "37px" }}
              />
            </p>
          ) : (
            <>
              <p
                onClick={() => {
                  setSelectedInformation([
                    newObj.drone_req_num,
                    newObj.brand_model,
                    newObj.registration_date,
                    newObj.caat,
                    newObj.nbtc,
                    newObj.regis_status_text,
                  ]);

                  //setO_id(newObj.operation_id);
                  setDrone_ID(newObj.drone_id);
                  handlegetdatadrone(newObj.drone_id);
                  setCheckreply(newObj.regis_status_text);
                  //handleclick()
                }}
                style={{ cursor: "pointer" }}
              >
                <FaRegFileLines
                  style={{
                    width: "37px",
                    height: "37px",
                    color: "black",
                    opacity: "0.7",
                  }}
                />
              </p>
            </>
          )}
        </div>
      );
      return newObj;
    });
    console.log(newArray);
    setUpdatedArray(newArray);
  };
  const [globalFilter, setGlobalFilter] = useState(null);
  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0">ขึ้นทะเบียนโดรน</h4>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();

  const Body_Regist_Date = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MdDateRange />
        <div style={{ marginLeft: "2px" }}>
          {" "}
          {`${data.registration_date.substring(0, 10)}` +
            " " +
            `${data.registration_date.substring(11, 16)}`}
        </div>
      </div>
    );
  };
  const Body_owner_brand = (data) => {
    return (
      <div style={{ justifyContent: "center", alignItems: "center" }}>
        <div style={{ textAlign: "left" }}>
          <FaUserAstronaut /> {data.owner}
          <br />
          <GiDeliveryDrone /> {data.brand_model}
        </div>
      </div>
    );
  };
  const Body_CAAT_Status = (data) => {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <Regulator_Status status={data.caat} style={{ width: "80%" }} />
      </div>
    );
  };
  const Body_NBTC_Status = (data) => {
    return (
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Regulator_Status status={data.nbtc} />
      </div>
    );
  };

  const Body_Payment_Status = (data) => {
    return (
      <>
        {data.regis_status_text === "ตรวจสอบการชำระเงิน" ? (
          <div
            onClick={() => {
              setShowpayment(true);
              setDrone_ID(data.drone_id);
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              alt=""
              src={payment}
              style={{ width: "46px", height: "46px" }}
            />
            {/* <AiFillDollarCircle
              style={{ color: "green", width: "30px", height: "30px" }}
            /> */}
          </div>
        ) : (
          <>
            {data.regis_status_text === "ชำระค่าพิจารณาคำขอ" ? (
              <div>
                <Tooltip
                  title={
                    <span style={{ fontSize: "16px", fontFamily: "Kanit" }}>
                      รอผู้ขอขึ้นทะเบียนชำระค่าบริการ
                    </span>
                  }
                  placement="top"
                >
                  <PaidIcon
                    style={{
                      width: "36px",
                      height: "36px",
                      color: "gray",
                      opacity: 0.9,
                    }}
                  />
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </>
    );
  };
  const Body_Information = (data) => {
    console.log(data);
    let pending = [
      "ไม่อนุมัติเอกสาร รอการแก้ไข",
      "ยังไม่อนุมัติ",
      "อนุมัติเอกสาร",
    ];
    let usertype = isNBTC ? "nbtc" : "caat";
    let data_type = usertype === "nbtc" ? data.nbtc : data.caat;
    
    return (
      <>

      
        {pending.includes(data_type) &&
        data.regis_status_text != "ชำระค่าพิจารณาคำขอ" &&
        data.caat != "ไม่อนุมัติเอกสาร รอการแก้ไข" &&
        data.nbtc != "ไม่อนุมัติเอกสาร รอการแก้ไข" && (data_type === "อนุมัติเอกสาร" && (data.regis_status_text === "อยู่ระหว่างการพิจารณา"|| data.regis_status_text==="อนุมัติ"))? (
          
          <p
            onClick={() => {
              setSelectedInformation([
                data.drone_req_num,
                data.brand_model,
                data.registration_date,
                data.caat,
                data.nbtc,
                data.regis_status_text,
              ]);

              //setO_id(newObj.operation_id);
              setDrone_ID(data.drone_id);
              handlegetdatadrone(data.drone_id);
              setConfirmdrone(true);
              //handleclick()
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              alt=""
              src={docgif}
              style={{ width: "46px", height: "46px", background: "red" }}
            />
          </p>
        ) : (
          <>
            <p
              onClick={() => {
                setSelectedInformation([
                  data.drone_req_num,
                  data.brand_model,
                  data.registration_date,
                  data.caat,
                  data.nbtc,
                  data.regis_status_text,
                ]);

                //setO_id(newObj.operation_id);
                setDrone_ID(data.drone_id);
                handlegetdatadrone(data.drone_id);
                setCheckreply(data.regis_status_text);
                //handleclick()
              }}
              style={{ cursor: "pointer", margin: "auto" }}
            >
              <img
                alt=""
                src={fileicon}
                style={{ width: "36px", height: "36px" }}
              />
              {/* <FaRegFileLines style={{ width: "37px", height: "37px", color: "black", opacity: "0.7" }} /> */}
            </p>
          </>
        )}
      </>
    );
  };
  ///sort && filter
  const sortOrder = [
    "ไม่อนุมัติเอกสาร รอการแก้ไข",
    "ยังไม่อนุมัติ",
    "อนุมัติเอกสาร",
    "อนุมัติการลงทะเบียน",
    "ไม่อนุมัติการลงทะเบียน",
  ];
  const customSort = (event) => {
    const value = [...event.data]; // Clone the array to avoid modifying the original data
    value.sort((a, b) => {
      const value1 = a[event.field];
      const value2 = b[event.field];

      const index1 = sortOrder.indexOf(value1);
      const index2 = sortOrder.indexOf(value2);

      return (index1 - index2) * event.order;
    });
    console.log(value);
    return value;
  };
  function filtered(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.owner
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.brand_model
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.registration_date
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.nbtc
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.caat
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))
    );
    console.log(filtered);
    return filteredData;
  }

  return (
    <div className="container-main" style={{ width: "90%", marginLeft: "5%" }}>
      <div
        className="table-card-header"
        style={{
          color: "white",
          background: "linear-gradient(90deg, #b1bcc4b5 0%, #edf3f5 100%)",
        }}
      >
        <h4 className="header-main" style={{ color: "rgb(78 85 90)" }}>
          รายการคำขอขึ้นทะเบียนทั้งหมด
        </h4>
      </div>

      <div>
        <div style={{ textAlign: "end", marginTop: "35px" }}>
          <p>จำนวน {data.length} รายการ</p>
        </div>
        <DataTable
          value={globalFilter ? filtered(data) : data}
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          rows={5}
          rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
          header={header}
          emptyMessage="ไม่พบข้อมูล"
          tableStyle={{ minWidth: "50rem" }}
          style={{ fontFamily: "Kanit" }}
        >
          <Column
            header="วันที่ขอขึ้นทะเบียน"
            body={Body_Regist_Date}
            field={`registration_date`}
            sortable
            filterField="registration_date"
            dataType="date"
            bodyStyle={{ alignItems: "center", textAlign: "center" }}
            style={{ width: "12%" }}
          ></Column>
          <Column
            header={`ผู้ถือครอง / แบรนด์-รุ่น`}
            body={Body_owner_brand}
            field={"owner" && "brand_model"}
            sortable
            bodyStyle={{ alignItems: "center", textAlign: "center" }}
            style={{ width: "15%" }}
          ></Column>

          <Column
            header="สถานะการขึ้นทะเบียน CAAT"
            body={Body_CAAT_Status}
            field="caat"
            sortable
            sortFunction={customSort}
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "20%" }}
          ></Column>
          <Column
            header="สถานะการขึ้นทะเบียน NBTC"
            body={Body_NBTC_Status}
            field="nbtc"
            sortable
            sortFunction={customSort}
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "20%" }}
          ></Column>
          <Column
            header="ยืนยันการชำระเงิน"
            body={Body_Payment_Status}
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "10%" }}
          ></Column>
          <Column
            header="รายละเอียด"
            field={isNBTC ? "nbtc" : "caat"}
            body={Body_Information}
            sortable
            sortFunction={customSort}
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "10%" }}
          ></Column>
        </DataTable>

        <br />
      </div>

      {showInformation && (
        <RegulatorDroneModal
          toggleModal={showInformation}
          handleShowComment={handleShowComment}
          onHide={handleClose}
          viewInformation={createPost}
          content={datadrone}
          booleanConfirmDrone={confirmdrone}
          booleanInformationCheck={selectedInformation}
        />
      )}
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <Modal
        show={showcomment}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            onChange={(e) => {
              setComment(e.target.value);
            }}
            style={{
              height: "50px",
              width: "100%",
              borderWidth: "1px",
              borderRadius: "10px",
              display: "block",
            }}
          />
        </Modal.Body>
        <Modal.Footer style={{}}>
          <div style={{ display: "flex", width: "400px" }}>
            <button
              className="modal-button-approve"
              onClick={() => {
                handlesentcomment();
              }}
            >
              Submit
            </button>
            <button
              className="modal-button-unapprove"
              onClick={() => {
                setShowcomment(false);
              }}
            >
              ยกเลิก
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showpayment}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            การชำระเงิน
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>ชำระเงินเรียบร้อย</Modal.Body>
        <Modal.Footer style={{}}>
          <div style={{ display: "flex", width: "400px" }}>
            <button
              className="modal-button-approve"
              onClick={() => {
                handlePaymentconfirm();
              }}
              style={{ width: "200px" }}
            >
              ยืนยันการชำระเงิน
            </button>
            <button
              className="modal-button-unapprove"
              onClick={() => {
                setShowpayment(false);
              }}
            >
              ยกเลิก
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
